import type { Ref } from "vue";
import axios from "axios";
import { ref } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import type { Empleado } from "@/types/empleado";

export default function useEmpleado() {
  const store = useStore(key);

  let usuario: Ref<Empleado | null> = ref(null);
  let lstEmpleados: Ref<Empleado[]> = ref([]);

  async function obtenerEmpleado(email: string) {
    try {
      await axios
        .get(
          store.state.url + "api/Empleado/GetEmpleadoXEmail?email=" + email,
          {
            headers: {},
          }
        )
        .then((response) => {
          if (response.status == 200) {
            let solicitantePor: Empleado = response.data as Empleado;

            if (solicitantePor != null) {
              usuario.value = solicitantePor;
            }
          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
    } catch (error) {
      console.log(error);
    }
  }

  async function getEmpleados() {
    try {
      await axios
        .get(store.state.url + "api/Empleado/GetEmpleados", {
          headers: {},
        })
        .then((response) => {
          if (response.status == 200) {
            lstEmpleados.value = response.data as Empleado[];
          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
    } catch (error) {
      console.log(error);
    }
  }

  // return { obtenerEmpleado, solPorId, solPorNombre, autorizador, usuario };
  return { obtenerEmpleado, getEmpleados, usuario, lstEmpleados };
}
